<span class="mr-3">{{ value }} %</span>
<app-mazars-button [uid]="'zoomOutBtn'" [iconClass]="'pi pi-search-minus'" [inverted]="true" (onClick)="zoomOut()"
    [disabled]="value === 0"></app-mazars-button>
<mazars-slider [uid]="'uid'" class="mb-1" id="mazars-zoom-slider" [(ngModel)]="value" [min]="1" max="100" [step]="1"
    (onStepChanged)="onStepChanged()"></mazars-slider>
<app-mazars-button [uid]="'zoomInBtn'" [iconClass]="'pi pi-search-plus'" [inverted]="true" (onClick)="zoomIn()"
    [disabled]="value === 100"></app-mazars-button>